import { create } from "zustand";

export const useLoanStore = create((set) => ({
  incomeFormProfile: { monthly_income: 50000, out_time_income: "", other_income: "", is_mou: false },
  selectedLoan: null,
  formProfileData: null,
  firstFillFormData: {
    job_type: "พนักงานประจำ",
    hire_type: "พนักงานประจำ",
    job_name: "อื่นๆ",
    other_job_name: "-",
    jobLevel: "พนักงาน",
    current_company: "-",
    job_experience_in_year: 1,
    monthly_income: 50000,
    out_time_income: 0,
    other_income: 0,
    income_type: "รายเดือน",
    monthly_outcome: 0,
    debt_amount: 0,
    monthly_debt: 0,
    total_debt: 0,
    attachment: [],
  },
  secondFillFormData: null,
  thirdFillFormData: {
    bank_name: "KBANK",
    bank_account: "0000000000",
    attachment: [],
  },
  createdLoanId: null,
  setIncomeFormProfile: (data) => set({ incomeFormProfile: data }),
  setSelectedLoan: (data) => set({ selectedLoan: data }),
  setFormProfileData: (data) => set({ formProfileData: data }),
  setFirstFillFormData: (data) => set({ firstFillFormData: data }),
  setSecondFillFormData: (data) => set({ secondFillFormData: data }),
  setThirdFillFormData: (data) => set({ thirdFillFormData: data }),
  setCreatedLoanId: (data) => set({ createdLoanId: data }),
}));
